import React from 'react';

import GET_ALL_OSD_REASON from '@graphql/getallOsdReason';

import useList from '@hooks/useList';

import { ContentStyled } from '@components/Styles/Global';
import { TableStyled } from '@components/Styles/TableStyles';

function OsdReason() {
  const { data, loading } = useList({ query: GET_ALL_OSD_REASON });

  const columns = [
    {
      title: 'OSD Reason',
      dataIndex: 'Osd_Reason',
      key: 'Osd_Reason',
      render: (text) => (
        <span style={{ userSelect: 'text' }}>
          {text}
        </span>
      ),
    },
  ];

  return (
    <ContentStyled>
      <TableStyled
        size="small"
        loading={loading}
        dataSource={data}
        columns={columns}
        pagination
        scroll={{ x: true }}
      />
    </ContentStyled>
  );
}

export default OsdReason;
